// extracted by mini-css-extract-plugin
export default {"container":"TableThreeEstablishmentPage_container__-MQew","closeButton":"TableThreeEstablishmentPage_closeButton__96AH2"};